import React, { useState } from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { AppBar, Modal, Tab ,Tabs} from '@mui/material';
import { Loginform } from './Loginform';
import Signupform from './Signupform';
import GoogleButton from 'react-google-button';
import {signInWithPopup,GithubAuthProvider, GoogleAuthProvider, signInWithRedirect} from 'firebase/auth'
import { auth } from '../firebaseconfig';
import { toast } from 'react-toastify'
import LogoutIcon from '@mui/icons-material/Logout';
import {useAuthState} from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom';

const AccountCircle = () => {
    const[open,setopen]=useState(false)
    const[value,setvalue]=useState(0)
    const [user]=useAuthState(auth)
    
    const googleProvider=new GoogleAuthProvider()
    const handlesignin =()=>{
        signInWithPopup(auth,googleProvider).then((res)=>{
            toast.success('User logged in!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });
                handleclose()
        }).catch((err)=>{
            toast.error('User Login failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
        })
    }

    const handleclose =()=>{
        setopen(false)
    }
    const handleValueChange = (e,v)=>{
        setvalue(v)
    }
    const navigate = useNavigate()
    const handleuserclick =()=>{
        if(user)
        {
            navigate('/user')
        }
        else
        {
            setopen(true)
        }
    }
    const Logout=()=>{
        auth.signOut().then((res)=>{
            toast.success('Logged out', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });
        }).catch((err)=>{
            toast.error('logOut failed', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
        }
        )
    }
  return (
    <div>
        <AccountCircleIcon onClick={handleuserclick}/>
        {user && <LogoutIcon style={{cursor:'pointer'}} onClick={Logout}/>}
        <Modal 
            open={open}
            onClose={handleclose}
            style={{
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                backdropFilter:'blur(2px)'

            }}
        >
        <div className='box' style={{width: '400px' , textAlign:'center'}}>
            <AppBar position='static' style={{background:'transparent'}}>
                <Tabs value={value} onChange={handleValueChange} variant='fullWidth'>
                
                    <Tab label='login'  style={{color : 'white' }} />
                    <Tab label='Signup' style={{color: 'white' }} />
                </Tabs>
            </AppBar>
            {value == 0 && <Loginform handleclose={handleclose}/>}
            {value == 1 && <Signupform handleclose={handleclose}/>}
            <box>
            <span>OR</span>
            <GoogleButton style={{width:'100%',marginTop:'20px'}} onClick={handlesignin}/>
            </box>
            </div>
          
        </Modal>
    </div>
  )
}
export default AccountCircle